import script from "./legend.vue?vue&type=script&setup=true&lang=js"
export * from "./legend.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__